import React from "react";
import "./Cos.css"
import { Link } from "react-router-dom";
const Cos = () => {
  return (
  <div>
<div className="cos" data-aos="fade-up" data-aos-duration="800">
    <div className="title">맞춤 코스 제작</div>
    <div className="subtitle">완벽한 하루만의 맞춤 코스를 추천드려요.</div>
    <div className="imgbox" data-aos="fade-up" data-aos-duration="800">
      <p >현재 <span>HOT</span>한 데이트 장소</p>
      <div className="imgbox_1">
      <img src="images/cos1.jpg" alt="반지만들기카페" />
      
        <div className="blackbox_3">
        <div className="text">
          <div className="word">반지만들기카페 건대점</div>
          <div className="subword">반지만들기 2인</div>
        </div>
        </div>
      
     
      </div>
    </div>
    <div className="view"><Link to="/Sub1">더보기</Link></div>
  </div>
  </div>
  );
};

export default Cos;
